module.exports = __webpack_public_path__ + "static/media/share-icon.fd12a0ce.svg";